import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'atx-asterisk',
  template: `<span class="font-weight-bold asterisk"></span>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .asterisk:after {
        content: ' *';
      }
    `,
  ],
  standalone: false,
})
export class AsteriskComponent {}
